import React, {useState} from 'react';
import '../../styles/Login.css'
import {useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";


function Login() {
    const [inputs, setInputs] = useState({})
    const [creActive, setCreActive] = useState(false);
    const [banActive, setBanActive] = useState(false);
    const [newActive, setNewActive] = useState(false);
    const [banReason, setBanReason] = useState("");
    const [banEnd, setBanEnd] = useState("");
    const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const navigate = useNavigate();


    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}))
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        setCreActive(false);
        setBanActive(false);
        setNewActive(false);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: inputs['email'],
                password: inputs['password']
            })
        };
        fetch('https://api.industriegaming.fr/api/auth/login', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    // const error = (data && data.message) || response.status;
                    // return Promise.reject(error);
                    if (data?.reason === "banned") {
                        setBanReason(data.ban_reason || "Aucun motif fourni");
                        setBanEnd(data.ban_end || "Inconnue");
                        setBanActive(true);
                        return;
                    } else if (data?.reason === "not_confirmed") {
                        setNewActive(true);
                    } else {
                        setCreActive(true);
                    }
                    return;
                }
                setCreActive(false);
                localStorage.removeItem("expireSoonShown");

                setCookie('token', data.token, { path: "/", maxAge: 86400 })
                navigate("/dashboard");


            })
            .catch(error => {
                console.error(error);
                alert(error)
            });
    }

    return (
        <div className="LoginPage">
            <div className="LoginLeftBanner">
                <div className="LoginLeftBannerText">
                    <h1>Bienvenue sur PZ Admin</h1>
                    <p>Le système de gestion des script IndustrieGaming</p>
                </div>
            </div>
            <form className="LoginRight" onSubmit={handleSubmit}>
                <img src={require('../../assets/logo.png')}/>
                <label>Se connecter à PZ Admin</label>
                <input type="text" placeholder="Email" name="email" required onChange={handleChange}/>
                <input type="password" placeholder="Mot de passe" name="password" required autoComplete="off" onChange={handleChange}/>
                {banActive && (
                    <p className="error-form banned-account-msg">
                        <span>Votre compte a été banni !</span>
                        <br/>
                        Motif : <span className="ban-reason">{banReason}</span>
                        <br/>
                        Fin du ban : <span className="duration">{banEnd}</span>
                    </p>
                )}
                {newActive ? (
                <p className="error-form unconfirmed-account">
                    {/* Vous n'avez pas confirmer votre compte à l'aide du mail que nous vous avons envoyé. */}
                    Votre compte est suspendu. Veuillez contacter un administrateur pour plus d'informations.
                </p>
                ) : null }
                {creActive ? (
                    <p className="error-form bad-credentials">
                        Échec de connexion. Vérifiez vos identifiants.
                    </p>
                ) : null}
                <button type="submit">
                    <span>
                        <i class="fa-solid fa-lock"></i> Connexion
                    </span>
                </button>
                <a href="/register" className="register-link disabled">
                    <span><i class="fa-solid fa-plus" disabled></i> Créer un compte</span>
                </a>
                <p>
                    <a href="/reset_pass">Mot de passe oublié ?</a>
                </p>
            </form>
        </div>
    )
}

export default Login;